import * as yup from "yup";

const associationSchema = yup.object({
    name: yup.string().trim().required("Association Name is required.")
});

export default associationSchema;
